<template>
  <ModalDialog
      v-model:visible="show"
      :header="t('label.select-custom-broker')"
      position="center"
      :maximizable="false"
      style="width: 30vw; height: 36vh"
      @hide="onHide">

    <div class="field col-12 md:col-12">
      <label for="customBroker2">{{ t('label.select-custom-broker') }}</label>
      <div class="p-inputgroup">
        <Dropdown
            id="customBroker2"
            v-model="contratto.customBroker2"
            :options="customBrokers"
            optionLabel="nomeBreve"
            :placeholder="t('message.select-option')"
            :show-clear="true"
            :filter="true"
            :class="errorStyleClass(v$, 'customBroker2')">
        </Dropdown>
        <Button @click="invitaSoggetto(Roles.CUSTOM_BROKER)"
                icon="pi pi-user-plus"
                :label="t('label.soggetto.invita-custom-broker')"
                class="p-button-sm p-button-success invite-button"
                v-tooltip.top="t('label.soggetto.invita-custom-broker')"/>
      </div>
      <ErrorMessages field="customBroker2"/>
    </div>

    <!-- actions -->
    <template #footer>
      <Button :label="t('action.cancel')" icon="pi pi-times" class="p-button p-button-light" @click="hide"/>
      <Button :label="t('action.save')" icon="pi pi-check" class="p-button p-button-success p-float-right"
              @click="save"/>
    </template>

  </ModalDialog>
</template>

<script setup>
import {onMounted, onUnmounted, ref, provide} from "vue";
import {useI18n} from "vue-i18n";
import {SHOW_SELECT_CUSTOM_BROKER_DIALOG, SHOW_SOGGETTO_RICHIESTA_DATA_DIALOG} from "@/components/common/constants/Events";
import EventService from "@/services/EventService";
import ModalDialog from "@/components/common/ModalDialog";
import soggettoRestService from "@/services/SoggettoRestService";
import ErrorMessages from "@/components/common/ErrorMessages";
import useCommon from "@/composable/useCommon"
import useVuelidate from "@vuelidate/core";
import Roles from "@/components/common/constants/Roles";
import contrattoRestService from "@/services/ContrattoRestService";
import {helpers, required} from "@vuelidate/validators";
import useMessage from "@/composable/useMessage";
import {useStore} from "vuex";

const {t} = useI18n();
const show = ref(false);
const {success} = useMessage();
const {errorStyleClass} = useCommon();
const store = useStore();

const contratto = ref();
const customBrokers = ref([]);


const rules = {
  customBroker2: {required: helpers.withMessage(t("validation.required", {field: t("label.custom_broker")}), required)}
};
const v$ = useVuelidate(rules, contratto, {$scope: 'selectCustomBroker'});

onMounted(() => {
  EventService.on(SHOW_SELECT_CUSTOM_BROKER_DIALOG, onShow);
})

onUnmounted(() => {
  EventService.off(SHOW_SELECT_CUSTOM_BROKER_DIALOG, onShow);
})

const onShow = async (contr) => {
  contratto.value = contr;
  show.value = true;
  customBrokers.value = await soggettoRestService.customBrokers();


  contratto.value.customBroker2 = null;
  if (null != contratto.value.customBroker2Eori && null != customBrokers.value) {
    contratto.value.customBroker2 = customBrokers.value.filter(s => s.eori === contratto.value.customBroker2Eori)[0];
  }

}

const invitaSoggetto = (ruolo) => {
  EventService.emit(SHOW_SOGGETTO_RICHIESTA_DATA_DIALOG, {ruolo: ruolo});
}

const onHide = () => {
  v$.value.$reset();
}

const hide = () => {
  show.value = false;
}

const save = async () => {
  await v$.value.$validate();
  if (!v$.value.$invalid) {
    await contrattoRestService.selectSecondCustomBroker(contratto.value, contratto.value.customBroker2);
    await store.dispatch("contratto/loadAll"); // operazone onerosa, aggiornamento selettivo... avendo tempo...
    success();
    hide();
  }
}

provide("v$", v$);
</script>

<style scoped>

</style>